import filterData from '../__mock__/filter';
import catalogsData from '../__mock__/catalogs';
import configData from '../__mock__/config';

import {
  getHXProductsDetailInfoAction, getHXFilterManageListAction,
  getHXLanguageAction,getLanguageAction, getHXCatalogsAction, getHXFilterAction, getHXProductsDetailAction,
  getHXAllCatalogs, getHXOrderManageAction, getHXProductsFieldManageAction, getHXSearchKeywordsManageAction, getArticles, postCateOrArticel, updateCateOrArticel, deleteCateOrArticel, changeArticles
} from '@ivymobi/orbit-core/business/productCenter';
import Utills from '@ivymobi/orbit-core/util/utills';


export const fetchFilterData = (dispatch, user, tenant, id?: string, nameFilter?: string) => {
  return new Promise<any>((resolve) => {
    dispatch(getHXFilterAction({ user, tenant, id, nameFilter })).then(res => {
      resolve(res);
    });
  });
};

export const fetchCatalogs = (dispatch, user, tenant, catalogId?: string, nameFilter?: string) => {
  return new Promise<any>((resolve) => {
    console.log('catalogId ====>>', catalogId);
    dispatch(getHXCatalogsAction({ user, tenant, catalogId, nameFilter })).then(res => {
      resolve(res);
    });
  });
};

export const fetchProduct = (dispatch, user, tenant, id?: string) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise<any>(async (resolve) => {
    const [detail, info] = await Promise.all([
      dispatch(getHXProductsDetailAction({ user, tenant, id })),
      dispatch(getHXProductsDetailInfoAction({ user, tenant, id }))
    ]);
    resolve({ ...detail, __infoText__: Utills.getValueByLanguage(null,info?.text)});
  });
};

export const fetchConfig = (dispatch, user, tenant, local) => {
  return new Promise<any>((resolve) => {
    dispatch(getLanguageAction({ user, tenant, local: local })).then(res => {
      resolve(res);
    });
  });
};

export const fetchAllCatalogs = (dispatch, user, tenant) => {
  return new Promise<any>((resolve) => {
    dispatch(getHXAllCatalogs({ user, tenant })).then(res => {
      resolve(res);
    });
  });
};
export const fetchArticles = (dispatch, user, tenant,id) => {
  return new Promise<any>((resolve) => {
    dispatch(getArticles({id, user, tenant })).then(res => {
      resolve(res);
    });
  });
};
export const fetchChangeArticles = (dispatch, user, tenant,id) => {
  return new Promise<any>((resolve) => {
    dispatch(changeArticles({...id, user, tenant })).then(res => {
      resolve(res);
    });
  });
};

export const fetchAddArticles = (dispatch, user, tenant,payload) => {
  return new Promise<any>((resolve) => {
    dispatch(postCateOrArticel({...payload, user, tenant })).then(res => {
      resolve(res);
    });
  });
};
export const fetchAlterArticles = (dispatch, user, tenant,payload) => {
  return new Promise<any>((resolve) => {
    dispatch(updateCateOrArticel({...payload, user, tenant })).then(res => {
      resolve(res);
    });
  });
};export const fetchDeleteArticles = (dispatch, user, tenant,payload) => {
  return new Promise<any>((resolve) => {
    dispatch(deleteCateOrArticel({...payload, user, tenant })).then(res => {
      resolve(res);
    });
  });
};
export const fetchOrderList = (dispatch, user, tenant) => {
  return new Promise<any>((resolve) => {
    dispatch(getHXOrderManageAction({ user, tenant })).then(res => {
      resolve(res);
    });
  });
};

export const fetchProductFieldList = (dispatch, user, tenant, id) => {
  return new Promise<any>((resolve) => {
    dispatch(getHXFilterManageListAction({ user, tenant, id })).then(res => {
      resolve(res);
    });
  });
};

export const fetchSearchKeywordList = (dispatch, user, tenant) => {
  return new Promise<any>((resolve) => {
    dispatch(getHXSearchKeywordsManageAction({ user, tenant })).then(res => {
      resolve(res);
    });
  });
};